import React, { useState, useEffect } from 'react';

import System from "../../../helper/system";
import { useBOMStore } from "../../../hooks/bom";
import { useAxiosIndicatorCheck } from "../../../store/hook/useAxiosIndicatorCheck";
const bomId = System.getParams().bomId;

const BomCreateProjectPopup = (props) => {
    const [__check] = useAxiosIndicatorCheck();
    const { data, SetStatus } = props
    const [projectName, SetProjectName] = useState('');
    const [projectNameError, SetProjectNameError] = useState('');
    const [{ }, { }, {create_project }] = useBOMStore();
    const loader = __check('BOM_PROJECT_OPERATION_API_CALL').status;

    const onHide = (action = true) => {
        SetStatus(false)
    };

    const createProjectNow = async () => {
        let error = false
        if (projectName.trim().length === 0) {
            error = true;
            SetProjectNameError('Please enter project name')
        } else if (projectName.trim().length > 100) {
            error = true;
            SetProjectNameError('Please use less than 100 Characters')
        } else {
            error = false
            SetProjectNameError('');
        }

        if (!error) {
            let res = await create_project({ projectName, bomId });
            if (res && res.isSuccessFull) {
                onHide()
                SetProjectName('');
                if (data.props_afterBOMCreation !== undefined) {
                    await data.props_afterBOMCreation();
                }
            } else {
                SetProjectNameError(res?.Message || "Something went wrong");
            }
        }
    };

    return (
        <>
            <div className="avnet-modal">
                <div className="avnet-modal-inner">
                    <button type="button" className="close py-3" data-dismiss="modal" disabled={loader}
                        onClick={onHide}>×
                    </button>
                    <div className="modal-header pb-2">
                        <h4 className="modal-title text-center" id="myModalLabel">Create New Project</h4>
                    </div>
                    <div className="modal-body">
                        <div className="form-group mb-4">
                            <label htmlFor="Name">Project Name*</label>
                            <input type="Name" placeholder='Enter Project Name' className={projectNameError ? "form-control form-control-sm error" : "form-control form-control-sm"} id="Name"
                                value={projectName}
                                onChange={(e) => {
                                    SetProjectName(e.target.value)
                                }}
                            />
                            <p className="error">{projectNameError}</p>
                        </div>
                    </div>
                    <div className="modal-footer text-center">
                        <button type="button" className="bs5 btn btn-secondary w145"
                                disabled={loader}
                                data-dismiss="modal"
                            onClick={onHide}>CANCEL
                        </button>
                        <button type="button" className="bs5 btn btn-primary w145"
                                disabled={loader}
                            onClick={async (e) => {
                                await createProjectNow()
                            }}>
                            {loader ? <i className="fa fa-spinner fa-spin" /> : "CREATE A PROJECT"}
                        </button>
                    </div>
                </div>
            </div>
        </>
    )
}

export default BomCreateProjectPopup;